{
  "pt": {
    "space": {
      "actions": {
        "assignOtherUnit": "Reatribuir à unidade",
        "assignSpace": "Atribuir espaço",
        "assignUnit": "Atribuir a uma unidade",
        "cancel": "Anular",
        "closeEdit": "Fechar Editar",
        "create_space": "Criar espaço",
        "delete": "Remover",
        "edit": "Editar",
        "goToSpaces": "Criar novos espaços",
        "new": "Espaço",
        "save": "Guardar",
        "unassign": "Desatribuir unidade",
        "unassignSpaces": "Anular a atribuição de espaços"
      },
      "attributes": {
        "category": "Tipo",
        "description": "Descrição",
        "level": "Nível",
        "name": "Nome",
        "price_value": "Valor total das vendas",
        "price_value_construction": "Valor da construção",
        "price_value_land": "Valor do terreno",
        "quotity": "Parcela do montante da transferência",
        "status": "Estado",
        "unit": "Unidade"
      },
      "category": {
        "bicyclestorage": "Armazenamento de bicicletas",
        "cellar": "Adega",
        "garagebox": "Lugar de Garagem",
        "other": "Outros",
        "outdoor_space": "Espaço exterior",
        "parkinglot": "Parque de estacionamento",
        "storage": "Arrumos",
        "winecellar": "Adega de vinho"
      },
      "labels": {
        "allSpacesAssigned": "Todos os espaços foram atribuídos a uma unidade.",
        "assignedSpaces": "Espaços atribuídos",
        "internal": "Interno",
        "noCategory": "Nenhum tipo definido",
        "noSpaceAssigned": "Nenhum espaço atribuído",
        "noSpaces": "Ainda não foram criados espaços",
        "notAssignedToUnit": "Nenhuma unidade atribuída",
        "onlyAvailableSpacesShown": "Só são apresentados os espaços disponíveis",
        "selectToUnassign": "Selecionar para anular a atribuição",
        "space": "Espaço",
        "spaces": "Espaços",
        "spacesProject": "Espaços no projeto {project}",
        "unassignedSpaces": "Espaços não atribuídos"
      },
      "validation": {
        "needCategory": "O tipo é obrigatório",
        "needName": "Nome necessário",
        "needNumber": "Deve ser um número (por exemplo, 95)",
        "selectSpace": "Selecionar pelo menos 1 espaço"
      }
    }
  }
}